import { Fragment } from 'react';
import { COMMUNITY_SERVER_TYPE, GAME_NAME, SEARCH_PARAMS, SERVICE_ALIAS, TAG_URL } from '@constants/index';
import { useSearchParams } from 'react-router-dom';
import type { ITag, ITagItem, l10nType } from '@type/index';

/**
 * 태그
 */
interface ITagArticleProps {
  item: any;
  l10n: l10nType;
  keyword: string;
  option: IOption;
}

const setTagItem = (item: ITag | ITagItem, option: IOption, searchParams: URLSearchParams): ITag | ITagItem | null => {
  const { path, serviceAlias } = option || {};
  const hasFront = item?.front; // Tag에선 front 데이터 추출해서 사용, Total에선 front 그대로 주입
  const isL2 = serviceAlias === SERVICE_ALIAS.LINEAGE2;
  const l2ServerName =
    isL2 && searchParams?.get(SEARCH_PARAMS.SERVER) === COMMUNITY_SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2AWKN
      ? `&${SEARCH_PARAMS.SERVER}=${GAME_NAME[serviceAlias].L2AWKN}`
      : '';

  return item && typeof item === 'object'
    ? hasFront
      ? {
          ...item,
          front: {
            ...item?.front,
            url: `${new URL(`${path}${TAG_URL[serviceAlias]}`, location.href)?.toString()}${encodeURIComponent(item?.front?.keyword)}${l2ServerName}`,
          },
        }
      : {
          ...item,
          url: `${new URL(`${path}${TAG_URL[serviceAlias]}`, location.href)?.toString()}${encodeURIComponent(item?.keyword)}${l2ServerName}`,
        }
    : null;
};

const transformCount = (str: string) => str.replace(/(\d)(?=(\d{3})+$)/g, '$1,');

const TagArticle = ({ item, l10n, keyword, option }: ITagArticleProps) => {
  const [searchParams] = useSearchParams();
  const data = setTagItem(item, option, searchParams);
  const title = (itemKeyword: string) => `#${itemKeyword?.split(keyword)?.join(`<strong>${keyword}</strong>`)}`;

  keyword = !keyword ? searchParams?.get(SEARCH_PARAMS.KEYWORD) : keyword;

  if (!data) {
    return <Fragment />;
  }

  const { url, keyword: itemKeyword, count } = data?.front || data;
  return (
    <div className="search-item-content">
      <div className="search-item-title">
        <a href={url} dangerouslySetInnerHTML={{ __html: title(itemKeyword) }}></a>
      </div>
      <div className="search-item-info">
        {l10n?.template?.boardList} {transformCount(`${count || 0}`)}
        {l10n?.template?.count}
      </div>
    </div>
  );
};

export default TagArticle;
